export default class RelationService {
  getAll(params) {
    const queryParams = Object.keys(params).map(k => encodeURIComponent(k) + '=' + encodeURIComponent(params[k])).join('&');
    return fetch('https://api.tradersr.com/api/relation?' + queryParams).then(res => res.json())
}
}